module.exports = __webpack_public_path__ + "static/img/5.5e48377c.png";